import { render, staticRenderFns } from "./PageMyForms.vue?vue&type=template&id=b293bc36&"
import script from "./PageMyForms.vue?vue&type=script&lang=js&"
export * from "./PageMyForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports